export default __webpack_public_path__ + "static/media/SEE_ERROR_MESSAGE.833cca3d.svg";